import React from "react";
import { useNavigate } from "react-router-dom";
import { FaPhone, FaBars, FaTimes } from "react-icons/fa";
import "./Features.css";
import logo from "../assets/logoelite.jpeg";
import awards from "../assets/Awards.png";
import studyMaterial from "../assets/StudyMaterial.jpg";
import analsis from "../assets/Analysis.jpg";
import micro from "../assets/Micro.jpg";
import support from "../assets/Support.jpg";
import question from "../assets/kids.jpg";

const Features = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = React.useState(false);

  const handleLoginClick = () => {
    navigate("/login");
  };

  // palette for headers / accents
  const colors = ["#6A1B9A", "#283593", "#0D47A1", "#00695C", "#FF8F00", "#C62828"];

  const features = [
    {
      id: 1,
      title: "Study Material",
      desc: "We have designed the study material uniquely to strengthen students foundational understanding. It includes detailed, topic-wise theory and multi-level exercises for Mathematics, Physics, Chemistry, and Biology.",
      img: studyMaterial,
    },
    {
      id: 2,
      title: "Micro Schedule",
            desc: "A structured subject teaching plan that organizes lessons and practice for students over a defined class duration.",
      img: micro,
    },
    {
      id: 3,
      title: "Academic Support",
            desc: "We provide a teacher handbook and dedicated support — doubts are clarified via phone and email.",
      img: support,
    },
    {
      id: 4,
      title: "Question Paper & OMR",
            desc: "We provide printed question papers for over 9 examinations and OMR sheets.",
      img: question,
    },
    {
      id: 5,
      title: "Analysis",
      desc: "We provide transparent, system-generated analysis for every examination.",
      img: analsis,
    },
    {
      id: 6,
      title: "Awards & Certificates",
            desc: "To boost students confidence, we provide participation certificates. A commemorative memento is awarded to each partner school.",
      img: awards,
    },
  ];

  return (
    <div>
      {/* Header */}
      <header className="header">
        <div className="logo-container">
          <img src={logo} alt="Elite Academy Logo" className="logo" />
          <span className="logo-text">Elite Academy</span>
        </div>

        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          <button className="nav-btn-link" onClick={() => navigate("/")}>HOME</button>
          <button className="nav-btn-link" onClick={() => navigate("/about")}>ABOUT US</button>
          <button className="nav-btn-link" onClick={() => navigate("/features")}>FEATURES</button>
          <button className="nav-btn-link" onClick={() => navigate("/contact")}>CONTACT US</button>
        </nav>

        <div className="header-right">
           <button
            className="sample-btn"
            onClick={() => navigate("/sample-copy")}
            aria-label="View sample copies"
            style={{
              marginLeft: 12,
              background: "linear-gradient(90deg,#ff7a18,#af002d)",
              color: "#fff",
              border: "none",
              padding: "8px 14px",
              borderRadius: 8,
              boxShadow: "0 6px 18px rgba(175,0,45,0.18)",
              cursor: "pointer",
              fontWeight: 700,
              letterSpacing: 0.2,
            }}
          >
            Sample Copy
          </button>
          <button className="login-btn" onClick={handleLoginClick}>
            LOGIN
          </button>
        </div>
      </header>

      {/* Hero / Intro */}
      <section
        className="features-hero"
        style={{
          background:
            "linear-gradient(135deg, rgba(81,45,168,0.9), rgba(24,118,210,0.85)), url('https://images.unsplash.com/photo-1496307042754-b4aa456c4a2d?auto=format&fit=crop&w=1600&q=60') center/cover no-repeat",
          color: "#fff",
          padding: "64px 20px",
          textAlign: "center",
        }}
      >
        <div className="hero-inner" style={{ maxWidth: 1100, margin: "0 auto" }}>
          <h1 style={{ fontSize: 40, marginBottom: 16 }}>Features</h1>
          <p
            className="features-intro"
            style={{
              fontSize: 18,
              lineHeight: 1.6,
              background: "rgba(255,255,255,0.06)",
              padding: "18px 20px",
              borderRadius: 8,
              margin: "0 auto",
            }}
          >
            Elite Academy blends curriculum-aligned resources with modern assessment and analytics to
            create a learning experience that is focused, measurable and personalised.
            From bite-sized schedules to live assessments and deep analytics — we make teaching more efficient
            and learning more effective.
          </p>
        </div>
      </section>

      {/* Features Grid - three columns, equally aligned */}
      <section className="features-section" style={{ padding: "48px 20px", background: "#fff" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <div
            className="features-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: 24,
              alignItems: "stretch",
            }}
          >
            {features.map((f) => {
              const accent = colors[(f.id - 1) % colors.length];
              return (
                <article
                  key={f.id}
                  className="feature-card"
                  style={{
                    background: "#fff",
                    borderRadius: 12,
                    overflow: "hidden",
                    boxShadow: "0 8px 24px rgba(16,24,40,0.06)",
                    display: "flex",
                    flexDirection: "column",
                    minHeight: 320,
                  }}
                >
                  {/* colored top stripe */}
                  <div style={{ height: 8, background: `linear-gradient(90deg, ${accent}, #fff)`, width: "100%" }} />
                  <div className="feature-img" style={{ height: 160, overflow: "hidden" }}>
                    <img src={f.img} alt={f.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  </div>

                  <div style={{ padding: 18, flex: 1, display: "flex", flexDirection: "column" }}>
                    <h3
                      className="feature-title"
                      style={{
                        margin: "0 0 10px",
                        color: accent,
                        fontSize: 20,
                        letterSpacing: "0.2px",
                        fontWeight: 700,
                      }}
                    >
                      {f.title}
                    </h3>
                    <p className="feature-desc" style={{ margin: 0, color: "#444", lineHeight: 1.6, flex: 1 }}>
                      {f.desc}
                    </p>
                    {/* small badge/footer */}
                    <div style={{ marginTop: 14, display: "flex", justifyContent: "flex-end", gap: 8 }}>
                      <span style={{
                        background: `${accent}22`,
                        color: accent,
                        padding: "6px 10px",
                        borderRadius: 20,
                        fontSize: 13,
                        fontWeight: 600,
                      }}>
                        {f.title.split(" ").slice(0,2).join(" ")}
                      </span>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Elite Academy. All Rights Reserved.</p>
      </footer>
    </div>
  );
};

export default Features;